// extracted by mini-css-extract-plugin
export default {"modal":"resetPasswordModal_modal__tEaP+","modalContent":"resetPasswordModal_modalContent__PCH9y","circle":"resetPasswordModal_circle__yht3L"};